import { Route, Routes } from 'react-router-dom';
import { ReviewEnvsTable } from './ReviewEnvsTable';
import { ReviewEnvDetailPage } from './ReviewEnvDetailPage';

export { hasReviewEnvs } from './common';

/**
 * Live status of a repo's PR review environments, from the review-envs
 * backend plugin (packages/backend/src/modules/reviewEnvs). Nothing here is in
 * the catalog: everything is read from the cluster on each refresh.
 *
 *   …/review-envs          list of envs
 *   …/review-envs/:name    one env: conditions, workloads, events, log links
 *
 * Shown for entities annotated with `reviewenv.ds25.io/repository: <repo>`.
 */
export const ReviewEnvsContent = () => (
  <Routes>
    <Route path="/" element={<ReviewEnvsTable />} />
    <Route path=":name" element={<ReviewEnvDetailPage />} />
  </Routes>
);
